import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LoggerService } from '@anecdotes/design-system/helpers';
import { SvgIconComponent } from './components';
import { SHOULD_INIT, SvgLoaderService, SvgRegistryService, SVG_SPRITE_PATH } from './services';

@NgModule({
  declarations: [SvgIconComponent],
  exports: [SvgIconComponent],
  imports: [CommonModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SvgIconsModule {
  static forRoot(svgSpritePath?: string): ModuleWithProviders<SvgIconsModule> {
    svgSpritePath = svgSpritePath || 'apps/svg-icons/sprites/icons-sprite.svg';

    return {
      ngModule: SvgIconsModule,
      providers: [
        SvgLoaderService,
        SvgRegistryService,
        LoggerService,
        { provide: SHOULD_INIT, useValue: true },
        { provide: SVG_SPRITE_PATH, useValue: svgSpritePath },
      ],
    };
  }
}
